import React from 'react';
import PropTypes from 'prop-types';
import styles from './CardLabelValue.css';

export function CardLabelValue({ label, children, testId }) {
  return (
    <div className={styles.valueContainer} data-test-id={`card-label-value-${testId}`}>
      <div data-test-id="card-label-value-label">{label}</div>
      <div className={styles.fillingColumn} />
      <div data-test-id="card-label-value-value">{children}</div>
    </div>
  )
}

CardLabelValue.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any,
  testId: PropTypes.string,
};
